var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { useState } from 'react';
var useComponentHighLight = function () {
    var _a = __read(useState([]), 2), highlightedElements = _a[0], setHighlightedElements = _a[1];
    var setOverlayOnElement = function (elem, id) {
        var rect = elem.getBoundingClientRect();
        var x = rect.left;
        var y = rect.top;
        var w = rect.width;
        var h = rect.height;
        var overlay = document.createElement('div');
        overlay.setAttribute('id', id);
        overlay.style.width = "".concat(w, "px");
        overlay.style.height = "".concat(h, "px");
        overlay.style.top = "".concat(y, "px");
        overlay.style.left = "".concat(x, "px");
        overlay.style.position = 'absolute';
        elem.classList.add('overlayActive');
        document.body.appendChild(overlay);
    };
    var highlightElement = function (targetID) {
        var elem = document.getElementById(targetID);
        if (elem) {
            setOverlayOnElement(elem, 'overlayID');
            setHighlightedElements(__spreadArray(__spreadArray([], __read(highlightedElements), false), [targetID], false));
        }
    };
    var removeHighlightElement = function (targetID) {
        var elem = document.getElementById(targetID);
        var myobj = document.getElementById('overlayID');
        elem === null || elem === void 0 ? void 0 : elem.classList.remove('overlayActive');
        myobj === null || myobj === void 0 ? void 0 : myobj.remove();
        var previouslyHighlighted = __spreadArray([], __read(highlightedElements), false);
        var targetIDIndex = previouslyHighlighted === null || previouslyHighlighted === void 0 ? void 0 : previouslyHighlighted.indexOf(targetID);
        previouslyHighlighted === null || previouslyHighlighted === void 0 ? void 0 : previouslyHighlighted.splice(targetIDIndex, 1);
        setHighlightedElements(__spreadArray([], __read(previouslyHighlighted), false));
    };
    return {
        highlightElement: highlightElement,
        removeHighlightElement: removeHighlightElement,
        highlightedElements: highlightedElements
    };
};
export default useComponentHighLight;
//# sourceMappingURL=useComponentHighlight.js.map